import {Three as THREE} from "@cm/material-nodes/three"
import {SceneNodes} from "@cm/template-nodes"
import {anyDifference, objectFieldsDifferent} from "@template-editor/helpers/change-detection"
import {ThreeObject, mathIsEqual, setThreeObjectPart, updateTransform} from "@template-editor/helpers/three-object"
import {DisplayMode, ThreeSceneManagerService} from "@template-editor/services/three-scene-manager.service"

export class ThreeCuboid extends ThreeObject<SceneNodes.Cuboid> {
    protected override renderObject: THREE.Group
    private mesh: THREE.Mesh<THREE.BufferGeometry, THREE.MeshBasicMaterial>
    private edgeLines: THREE.LineSegments<THREE.BufferGeometry, THREE.LineBasicMaterial>

    constructor(threeSceneManagerService: ThreeSceneManagerService, onAsyncUpdate: () => void) {
        super(threeSceneManagerService, onAsyncUpdate)
        this.mesh = new THREE.Mesh(new THREE.BoxGeometry(1, 1, 1), new THREE.MeshBasicMaterial({color: 0xcccccc, transparent: true, opacity: 0.5}))
        this.edgeLines = new THREE.LineSegments(new THREE.EdgesGeometry(this.mesh.geometry), new THREE.LineBasicMaterial({color: 0x000000}))

        this.renderObject = new THREE.Group()
        this.renderObject.add(this.mesh)
        this.renderObject.add(this.edgeLines)
        setThreeObjectPart(this.getRenderObject(), this)

        this.onDisplayModeChange(threeSceneManagerService.$displayMode())
    }

    override onDisplayModeChange(displayMode: DisplayMode) {
        this.renderObject.visible = displayMode === "editor"
    }

    override setup(sceneNode: SceneNodes.Cuboid) {
        return anyDifference([
            objectFieldsDifferent(
                sceneNode,
                this.parameters,
                ["transform", "width", "height", "depth"],
                (valueA, valueB) => {
                    if (typeof valueA === "object" && typeof valueB === "object") return mathIsEqual(valueA, valueB)
                    return valueA === valueB
                },
                ({transform, width, height, depth}) => {
                    updateTransform(transform, this.renderObject)
                    this.mesh.scale.set(width, height, depth)
                    this.edgeLines.scale.set(width, height, depth)
                },
            ),
        ])
    }

    override dispose() {
        this.mesh.geometry.dispose()
        this.mesh.material.dispose()
        this.edgeLines.geometry.dispose()
        this.edgeLines.material.dispose()
    }
}
